import { AbstractControl } from '@angular/forms';

// import { REGEX_PASSWORD } from '../constants';

export const passwordValidator = (control: AbstractControl): { [key: string]: boolean } | null => {
    // if (!control.value.match(REGEX_PASSWORD)) {
    //     return { password: true };
    // }
    return null;
}
